import { Card, CardContent, Typography } from '@mui/joy';
import { t } from 'i18next';
import { Control, FieldError, Merge } from 'react-hook-form';

import { FormField } from 'core/components';
import { AllowedDecimalsTooltip } from 'core/elements';
import { InputType } from 'core/enums';
import { PricingHelper } from 'pricing/helpers';
import { Color, Level, Variant } from 'theme/enums';

interface IProps {
  cost: number;
  label?: string | JSX.Element;
  values: {
    price?: number;
    decimals?: number;
    onPriceChange?: (value: number) => void;
    margin?: number;
    control?: Control;
    error?: Merge<FieldError, { message: string }>;
    isPriceLocked?: boolean;
  };
}
export const PriceCard = ({
  label = t('labelPrice'),
  cost,
  values: {
    price = null,
    decimals = null,
    onPriceChange = null,
    margin = null,
    control = null,
    error = null,
    isPriceLocked = false,
  } = {},
}: IProps) => {
  const priceValue = PricingHelper.formatPricing({
    amount: margin ? PricingHelper.computePrice(cost, margin, false) : price,
    decimals,
    displayZero: false,
  });

  return (
    <Card
      variant={Variant.PLAIN}
      sx={{ width: '100%', height: '100%' }}
      {...(isPriceLocked && { color: Color.DANGER, variant: Variant.SOFT })}
    >
      <CardContent>
        <Typography color={Color.NEUTRAL} level={Level.BODY_XS} pb={1}>
          {label}
        </Typography>

        {!control && <Typography level={Level.TITLE_LG}>{priceValue}</Typography>}

        {control && (
          <FormField
            name="price"
            type={InputType.NUMBER_INPUT}
            inputProps={{
              placeholder: t('labelPrice'),
              control: control,
              error: error,
              onChange: ({ target: { value }, source }) => {
                if (source !== 'event' || !onPriceChange) {
                  return;
                }

                onPriceChange(value);
              },
              disabled: isPriceLocked,
              endDecorator: <AllowedDecimalsTooltip decimals={decimals} />,
              slotProps: {
                input: {
                  thousandSeparator: true,
                  decimalScale: decimals,
                  prefix: '$',
                },
              },
            }}
          />
        )}
      </CardContent>
    </Card>
  );
};
